module.exports = __webpack_public_path__ + "img/87.ee1c8ca3.png";